import { useRef, useEffect, useState } from 'react';
import { getActiveState, parseJSON } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';
import { loadImages } from '../helpers/preload';

export const useBroadcast = () => {
  const {
    user,
    carousel,
    repeatCount,
    startFrom,
    duration,
    durationF2 = 4000,
  } = useGetParams();

  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const lastMessageIdRef = useRef(0);

  const [currentMessage, setCurrentMessage] = useState(null);
  const nextMessageIndexRef = useRef(-1);
  const messagesRef = useRef([]);

  const [currentMessageF2, setCurrentMessageF2] = useState(null);
  const messagesRefF2 = useRef([]);
  const nextMessageIndexRefF2 = useRef(-1);

  const rotate = useRef('+');

  // задержка интервала смены сообщений
  const [delay, setDelay] = useState(duration);
  const [delayF2, setDelayF2] = useState(durationF2);
  // id предыдущего запущенного интерактива
  const prevIdBroadcast = useRef('');
  // id текущего запущенного интерактива
  const iactiveIdRef = useRef('');

  const protocol = window?.location?.protocol || 'https:';

  const getBroadcastInfo = async () => {
    if (!user) {
      return;
    }

    try {
      const response = await fetch(
        `${protocol}//api.stream.iactive.pro/titreInfo?user=${user}&from=${lastMessageIdRef.current}&type=1`,
        { cache: 'no-store' },
      );
      const data = await response.json();

      if (!data) return;

      let { messagesList, deletedMessagesIdList, visibility, iactiveId } = data;

      // очистка при остановке\смене интерактива, при остановке iactiveId = ""
      if (iactiveIdRef.current !== iactiveId) {
        if (
          currentMessage &&
          iactiveId &&
          iactiveId !== prevIdBroadcast.current // если === , значит prevIdBroadcast был остановлен и теперь запущен, и не нужно обнулять
        ) {
          messagesRef.current = [];
          messagesRefF2.current = [];
          setCurrentMessage(null);
          setCurrentMessageF2(null);
          nextMessageIndexRef.current = -1;
          nextMessageIndexRefF2.current = -1;
        }
      }

      // сохранение id нового запущенного интерактива.
      if (iactiveId && iactiveId !== prevIdBroadcast.current) {
        // Если уже был предыдущий запущенный интерактив, то показать сообщение сразу без задержки.
        if (prevIdBroadcast.current) {
          // console.log('смена интреактива');
          setDelay(0);
          setDelayF2(0);
        }
        prevIdBroadcast.current = iactiveId;
      }

      // Определяем видимость титра

      if (!visibility && visibility !== isVisible) {
        setIsVisible(false);
        return;
      } else if (visibility && visibility !== isVisible) {
        setIsVisible(true);
      }

      // Определяем состояние (S1, S2 ...)

      if (
        data?.statusList[0]?.state &&
        getActiveState(data?.statusList[0]?.state) !== currentState
      ) {
        setCurrentState(getActiveState(data?.statusList[0].state));
      }

      // если список сообщений пустой
      if (
        !messagesList ||
        (Array.isArray(messagesList) && messagesList.length === 0)
      ) {
        // Удаляем сообщения по команде пользователя

        // если имеются в списке сообщений F1 удаленные
        if (
          messagesRef.current.some((el) =>
            deletedMessagesIdList.includes(+el.id),
          )
        ) {
          const newState = messagesRef.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id),
          );

          for (let i = 0; i < messagesRef.current.length; i++) {
            if (
              !newState.find(
                (el) =>
                  nextMessageIndexRef.current &&
                  el.id ===
                    messagesRef.current[nextMessageIndexRef.current]?.id,
              )
            ) {
              if (
                messagesRef.current[nextMessageIndexRef.current] ===
                messagesRef.current[messagesRef.current.length - 1]
              ) {
                nextMessageIndexRef.current--;
                if (nextMessageIndexRef.current < 0)
                  nextMessageIndexRef.current = 0;
              }
            }
            if (
              i < nextMessageIndexRef.current &&
              !newState.find((el) => el.id === messagesRef.current[i].id)
            ) {
              nextMessageIndexRef.current--;
              if (nextMessageIndexRef.current < 0)
                nextMessageIndexRef.current = 0;
            }
          }

          messagesRef.current = newState;
        }

        // если имеются в списке сообщений F2 удаленные
        if (
          messagesRefF2.current.some((el) =>
            deletedMessagesIdList.includes(+el.id),
          )
        ) {
          const newState = messagesRefF2.current.filter(
            (el) => !deletedMessagesIdList.includes(+el.id),
          );

          for (let i = 0; i < messagesRefF2.current.length; i++) {
            if (
              !newState.find(
                (el) =>
                  nextMessageIndexRefF2.current &&
                  el.id ===
                    messagesRefF2.current[nextMessageIndexRefF2.current]?.id,
              )
            ) {
              if (
                messagesRefF2.current[nextMessageIndexRefF2.current] ===
                messagesRefF2.current[messagesRefF2.current.length - 1]
              ) {
                nextMessageIndexRefF2.current--;
                if (nextMessageIndexRefF2.current < 0)
                  nextMessageIndexRefF2.current = 0;
              }
            }
            if (
              i < nextMessageIndexRefF2.current &&
              !newState.find((el) => el.id === messagesRefF2.current[i].id)
            ) {
              nextMessageIndexRefF2.current--;
              if (nextMessageIndexRefF2.current < 0)
                nextMessageIndexRefF2.current = 0;
            }
          }

          messagesRefF2.current = newState;
        }

        //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
        if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
          lastMessageIdRef.current = 0;
          iactiveIdRef.current = iactiveId;
          return;
        } else {
          iactiveIdRef.current = iactiveId;
          lastMessageIdRef.current =
            messagesList[0]?.id || lastMessageIdRef.current;
        }
        return;
      }

      // оставляем только сообщения с вложениями с типом image
      // messagesList = messagesList.filter(
      //   (el) =>
      //     Array.isArray(el.message.attachments) &&
      //     el.message.attachments.length > 0 &&
      //     typeof el.message.attachments[0] === 'object' &&
      //     el.message.attachments[0].type === 'image'
      // );

      //запоминаем id последнего сообщения, для дальнейших запросов и обнуляем при переключении интерактивов
      if (iactiveIdRef.current && iactiveIdRef.current !== iactiveId) {
        lastMessageIdRef.current = 0;
        iactiveIdRef.current = iactiveId;
        return;
      } else {
        iactiveIdRef.current = iactiveId;
        lastMessageIdRef.current =
          messagesList[0]?.id || lastMessageIdRef.current;
      }

      let resultF1 = [];
      let resultF2 = [];

      messagesList = messagesList.map((m) => ({
        ...m,
        message: {
          ...m.message,
          attachments: parseJSON(m.message?.attachments),
        },
      }));

      messagesList.forEach((el) => {
        if (el.titrTag !== 'F1') {
          return;
        }

        let clearContent = el.message?.content?.replaceAll(/\r?\n/g, '');
        if (!clearContent) {
          return;
        }
        if (
          !messagesRef.current.find(
            (elm) =>
              elm.message.content === clearContent &&
              elm.message.author === el.message.author &&
              elm.titrTag === el.titrTag,
          )
        ) {
          resultF1.push(el);
        }
      });

      messagesList.forEach((el) => {
        if (el.titrTag !== 'F2') {
          return;
        }
        if (!el?.message?.attachments?.[0]) {
          return;
        }
        if (
          typeof el.message?.attachments?.[0] === 'object' &&
          el.message?.attachments?.[0]?.url &&
          !messagesRef.current.find(
            (elm) =>
              typeof elm.message.attachments?.[0] === 'object' &&
              typeof el.message.attachments?.[0] === 'object' &&
              elm.message.attachments?.[0]?.url ===
                el.message.attachments?.[0]?.url,
          )
        ) {
          resultF2.push(el);
        } else if (
          !messagesRef.current.find(
            (elm) =>
              elm.message.content === el.message.content &&
              elm.message.author === el.message.author &&
              elm.titrTag === el.titrTag,
          )
        ) {
          resultF2.push(el);
        }
      });

      // предзагрузка аватарок и вложений
      let urlsAvatar =
        resultF1
          ?.map((m) => m.message.image)
          ?.filter((u) => u && u !== '1')
          ?.slice(-repeatCount) || [];
      let urlsAttach =
        resultF2
          ?.map((m) => m.message?.attachments?.[0]?.url)
          ?.slice(-repeatCount) || [];

      const urls = [...urlsAttach, ...urlsAvatar];

      if (urls && urls.length !== 0) {
        loadImages(urls);
      }

      messagesRef.current = [
        ...messagesRef.current,
        ...resultF1.reverse(),
      ].slice(-repeatCount);

      messagesRefF2.current = [
        ...messagesRefF2.current,
        ...resultF2.reverse(),
      ].slice(-repeatCount);
    } catch (error) {
      console.error(error);
    }
  };

  const iterateIndex = (array) => {
    if (carousel === '1') {
      if (!array.length) {
        nextMessageIndexRef.current = -1;
        return;
      }
      if (nextMessageIndexRef.current < array.length - 1) {
        nextMessageIndexRef.current++;
      } else {
        if (messagesRef.current.length >= startFrom) {
          messagesRef.current = messagesRef.current.slice(-repeatCount);
          nextMessageIndexRef.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRef.current < messagesRef.current.length - 1)
        nextMessageIndexRef.current++;
      else {
        nextMessageIndexRef.current = messagesRef.current.length - 1;
      }
    }
  };

  const iterateIndexF2 = (array) => {
    if (carousel === '1') {
      if (!array.length) {
        nextMessageIndexRefF2.current = -1;
        return;
      }
      if (nextMessageIndexRefF2.current < array.length - 1) {
        nextMessageIndexRefF2.current++;
      } else {
        if (messagesRefF2.current.length >= startFrom) {
          messagesRefF2.current = messagesRefF2.current.slice(-repeatCount);
          nextMessageIndexRefF2.current = 0;
        }
      }
    } else {
      if (nextMessageIndexRefF2.current < messagesRefF2.current.length - 1)
        nextMessageIndexRefF2.current++;
      else {
        nextMessageIndexRefF2.current = messagesRefF2.current.length - 1;
      }
    }
  };

  const [visibleTab, setVisibleTab] = useState(true);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // console.log('Вкладка стала активной - сбрасываем анимации');

        setVisibleTab(true);
      } else {
        setVisibleTab(false);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    getBroadcastInfo().then(() => {
      if (messagesRef.current && messagesRef.current.length > 0) {
        iterateIndex(messagesRef.current);

        setCurrentMessage({
          ...messagesRef.current[nextMessageIndexRef.current],
        });
      }

      if (messagesRefF2.current && messagesRefF2.current.length > 0) {
        iterateIndexF2(messagesRefF2.current);

        if (rotate.current === '+') {
          rotate.current = '-';
        } else {
          rotate.current = '+';
        }

        setCurrentMessageF2({
          ...messagesRefF2.current[nextMessageIndexRefF2.current],
          rotateSign: rotate.current,
        });
      }
    });
  }, []);

  // Выбор сообщения для показа
  useInterval(
    () => {
      iterateIndex(messagesRef.current);
      if (
        messagesRef.current &&
        messagesRef.current.length === 0 &&
        currentMessage !== null
      ) {
        setCurrentMessage(null);
      } else if (
        messagesRef.current &&
        messagesRef.current.length > 0 &&
        (!currentMessage ||
          (currentMessage &&
            currentMessage.id !==
              messagesRef.current[nextMessageIndexRef.current].id))
      ) {
        setCurrentMessage({
          ...messagesRef.current[nextMessageIndexRef.current],
        });

        // добавление задержки интервалу, после отработки по нулевой задержке (delay === 0)
        if (delay === 0) {
          setDelay(duration);
        }
      }
    },
    isVisible && currentState === 'S3' && visibleTab ? delay : null,
  );

  useInterval(
    () => {
      iterateIndexF2(messagesRefF2.current);
      if (
        messagesRefF2.current &&
        messagesRefF2.current.length === 0 &&
        currentMessageF2 !== null
      ) {
        setCurrentMessageF2(null);
      } else if (
        messagesRefF2.current &&
        messagesRefF2.current.length > 0 &&
        (!currentMessageF2 ||
          (currentMessageF2 &&
            currentMessageF2.id !==
              messagesRefF2.current[nextMessageIndexRefF2.current].id))
      ) {
        if (rotate.current === '+') {
          rotate.current = '-';
        } else {
          rotate.current = '+';
        }

        setCurrentMessageF2({
          ...messagesRefF2.current[nextMessageIndexRefF2.current],
          rotateSign: rotate.current,
        });

        // добавление задержки интервалу, после отработки по нулевой задержке (delay === 0)
        if (delayF2 === 0) {
          setDelayF2(durationF2);
        }
      }
    },
    isVisible && (currentState === 'S2' || currentState === 'S3') && visibleTab
      ? delayF2
      : null,
  );

  // Получение информации о титре
  useInterval(getBroadcastInfo, 1000);

  return {
    currentState,
    isVisible,
    currentMessage,
    currentMessageF2,
  };
};
